import { api } from "."

const fileApi = {
    create: async (formData: FormData) => {
        return await api.post('files/upload', formData)
    }
}

export default fileApi